module.exports = __webpack_public_path__ + "static/index.spec.js.2f1041d1e455489247cc1edc60636662.snap";